import React, { useEffect, useState } from 'react';

import { CommonProps } from 'src/components/helpers/props';

import './index.scss';
import { useTranslation } from 'react-i18next';
import { Avatar, GlobeChatIcon } from 'fasoo-ui-component-next';
import { Member } from 'src/type/Workgroup';
import { AuthEntity } from 'src/store/auth/auth';
import usePopup from 'src/hooks/usePopup';
import UserStatusPopup from 'src/components/molecules/UserStatusPopup';
import i18n, { getFasooUiComponentLanguage, supportLanguages } from 'src/i18n';
import LanguageSelectPopup from 'src/components/molecules/LanguageSelectPopup';
import { useLocation, useNavigate } from 'react-router-dom';

export interface IProps extends CommonProps {
  handleLogOut: () => void;
  authEntity: AuthEntity | undefined;
  handleMenuToService?: () => void;
  moveToAdminSite?: () => void;
  memberInfo?: Member;
}

const HeaderStatusBar: React.FC<IProps> = ({
  handleLogOut,
  moveToAdminSite,
  authEntity,
  memberInfo,
}) => {
  const { t } = useTranslation(['common', 'headerStatus', 'userStatus']);
  const [selectedLan, setSelectedLan] = useState<string>(getFasooUiComponentLanguage());
  const userStatusPopup = usePopup();
  const langSelectPopup = usePopup();

  const navigate = useNavigate();
  const locationVal = useLocation();

  const handleSetLang = (lang: string): void => {
    setSelectedLan(lang);
    i18n.changeLanguage(lang);
    document.getElementById('root')?.setAttribute('lang', lang);
    document.documentElement.lang = lang;
  };

  const handleClickHeaderPopup = (type: string): void => {
    navigate(`${locationVal.pathname}?popup=${type}`);
  };

  const handleClosePopup = (type: string): void => {
    navigate(-1);
    if (type === 'lang') {
      langSelectPopup.closePopup();
    } else {
      userStatusPopup.closePopup();
    }
  };

  useEffect(() => {
    if (locationVal.search.length === 0) {
      if (langSelectPopup.opened) {
        langSelectPopup.closePopup();
      } else {
        userStatusPopup.closePopup();
      }
    } else {
      if (locationVal.search.includes('popup=lang')) {
        langSelectPopup.openPopup();
      } else if (locationVal.search.includes('popup=user')) {
        userStatusPopup.openPopup();
      }
    }
  }, [locationVal.search]);

  return (
    <div className="header-status-bar-root">
      <div className="globe-icon" onClick={() => handleClickHeaderPopup('lang')}>
        <GlobeChatIcon size="lg" classes="language-button" />
      </div>

      <div className="user-info-root" onClick={() => handleClickHeaderPopup('user')}>
        <Avatar size="sm" variant="self" onlineStatus={authEntity !== undefined ? true : false} />
      </div>
      {langSelectPopup.opened === true && (
        <LanguageSelectPopup
          currentLang={selectedLan}
          onClose={() => handleClosePopup('lang')}
          open={langSelectPopup.opened}
          changeLang={handleSetLang}
        />
      )}
      {userStatusPopup.opened === true && (
        <UserStatusPopup
          title={t('userStatus:currentUser')}
          open={userStatusPopup.opened}
          authEntity={authEntity}
          // authEntity={undefined}
          onClose={() => handleClosePopup('user')}
          handleLogOut={handleLogOut}
        />
      )}
    </div>
  );
};

export default HeaderStatusBar;
